import { render, staticRenderFns } from "./mandala-lag-display.component.vue?vue&type=template&id=397d6794&scoped=true&"
import script from "./mandala-lag-display.component.vue?vue&type=script&lang=ts&"
export * from "./mandala-lag-display.component.vue?vue&type=script&lang=ts&"
import style0 from "./mandala-lag-display.component.vue?vue&type=style&index=0&id=397d6794&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d6794",
  null
  
)

export default component.exports